import React, { PropsWithChildren } from 'react'
import { Modal } from 'antd'
import { ModalProps } from 'antd/lib/modal'
import { X } from 'react-feather'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TCustomModalProps extends ModalProps {}

function CustomModal(props: PropsWithChildren<TCustomModalProps>) {
	return (
		<Modal
			footer={null}
			closeIcon={<X />}
			visible={props.visible}
			onOk={props.onOk}
			onCancel={props.onCancel}
			width={props.width}
			{...props}
		>
			{props.children}
		</Modal>
	)
}

export default CustomModal
